import React, { useState } from 'react';
import axios from 'axios';
import FadeInFromLeft from './FadeInFromLeft';
import './Welcome.css';

export default function BetaSignup({ isMobile }) {
  const [betaEmail, setBetaEmail] = useState("");
  const [betaSubmitted, setBetaSubmitted] = useState(false);

  const handleBetaSubmit = async (e) => {
    e.preventDefault();
    if (!betaEmail.trim()) return;

    try {
      const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/waiting-list`,
        { email: betaEmail },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      setBetaSubmitted(true);
      setBetaEmail('');
      setTimeout(() => setBetaSubmitted(false), 3800);
    } catch (err) {
      console.error(err);
      alert('Failed to submit email');
    }
  };

  return (
    <FadeInFromLeft delay={450}>
      <section
        className={`beta-signup ${isMobile ? 'mobile' : ''}`}
        aria-label="Beta Program Signup"
      >
        <h2 className={`beta-title ${isMobile ? 'mobile' : ''}`}>
          📰 NeuHawk News 📰
        </h2>
        <p className={`beta-description ${isMobile ? 'mobile' : ''}`}>
          Join the NeuHawk community of passionate graduate students. Be among the first to shape the future of networking and collaboration!
        </p>
        <form
          onSubmit={handleBetaSubmit}
          className={`beta-form ${isMobile ? 'mobile' : ''}`}
        >
          <input
            type="email"
            value={betaEmail}
            onChange={e => setBetaEmail(e.target.value)}
            placeholder="your.email@university.edu"
            className={`beta-input ${isMobile ? 'mobile' : ''}`}
            required
            aria-label="Email for Beta Sign Up"
          />
          <button
            type="submit"
            className={`beta-button ${isMobile ? 'mobile' : ''}`}
            disabled={betaSubmitted}
            aria-label={betaSubmitted ? "Email submitted successfully" : "Submit email for early access"}
          >
            {betaSubmitted ? "Submitted!" : "Join the Community"}
          </button>
        </form>
        <div className={`beta-features ${isMobile ? 'mobile' : ''}`}>
          <div className="beta-feature">
            <span role="img" aria-label="verified">✅</span> .edu verified
          </div>
          <div className="beta-feature">
            <span role="img" aria-label="community">👥</span> Grad community
          </div>
          <div className="beta-feature">
            <span role="img" aria-label="opportunity">✨</span> Life-changing opportunities
          </div>
        </div>
      </section>
    </FadeInFromLeft>
  );
}